import React from "react";
import ContainerAuthenticated from "containers/Authenticated";
import { AuthenticatedLayoutProvider, useAuthLayout } from "context/AuthLayoutContext";
import { useAutoReloadOnDeploy } from "hooks/checkAppVersion";
import useWebNotifications from "hooks/useWebNotifications";
import useNotificationCenter from "hooks/useNotificationCenter";

function LayoutInner({ children, portal }) {
  useAutoReloadOnDeploy();
  const notificationCenterEnabled = true;
  const { loadNotifications } = useNotificationCenter({
    enabled: notificationCenterEnabled,
    autoLoad: notificationCenterEnabled,
  });
  useWebNotifications({
    onForegroundMessage: notificationCenterEnabled ? loadNotifications : undefined,
  });
  const { layoutProps, isActive, setIsActive } = useAuthLayout();

  return (
    <ContainerAuthenticated portal={portal} {...layoutProps} isActive={isActive} setIsActive={setIsActive}>
      {children}
    </ContainerAuthenticated>
  );
}

export default function AuthenticatedLayout({ children, portal }) {

  return (
    <AuthenticatedLayoutProvider>
      <LayoutInner portal={portal}>{children}</LayoutInner>
    </AuthenticatedLayoutProvider>
  );
}
